<template>
  <div>
    <p class="pl-5">Оплата за електроенергію в Інтернеті доступна через електронні системи:</p>
    <v-row class="d-flex">
      <v-col class="d-flex justify-center" sm="6" md="4" lg="4" xl="3">
        <v-card class="d-flex  align-center pl-5 pr-5" height="150" width="250" v-on:click="openUrl('privatbank')">
          <v-img :src="require('@/assets/privatbank-logo.png')"></v-img>
        </v-card> 
      </v-col>

      <v-col class="d-flex justify-center" sm="6" md="4" lg="4" xl="3">
        <v-card class="d-flex align-center pl-5 pr-5" height="150" width="250" v-on:click="openUrl('easypay')">
          <v-img :src="require('@/assets/easypay-logo.png')"></v-img>
        </v-card> 
      </v-col>

      <v-col class="d-flex justify-center" sm="6" md="4" lg="4" xl="3">
        <v-card  class="d-flex align-center pl-5 pr-5" height="150" width="250" v-on:click="openUrl('portmone')">
          <v-img :src="require('@/assets/portmone-logo.png')"></v-img>
        </v-card> 
      </v-col>

      <v-col class="d-flex justify-center" sm="6" md="4" lg="4" xl="3">
        <v-card  class="d-flex align-center pl-5 pr-5" height="150" width="250" v-on:click="openUrl('ibox')">
          <v-img :src="require('@/assets/ibox-logo.png')"></v-img>
        </v-card> 
      </v-col>

      <v-col class="d-flex justify-center" sm="6" md="4" lg="4" xl="3">
        <v-card  class="d-flex align-center pl-5 pr-5" height="150" width="250" v-on:click="openUrl('ipay')">
          <v-img :src="require('@/assets/ipay-logo.png')"></v-img>
        </v-card>
      </v-col>

      <v-col class="d-flex justify-center" sm="6" md="4" lg="4" xl="3">
        <v-card  class="d-flex align-center pl-5 pr-5" height="150" width="250" v-on:click="openUrl('monobank')">
        <v-img :src="require('@/assets/monobank-logo.png')"></v-img>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import mixin from '@/mixins/widgetsMixins.js'
export default {
  name: 'dr-payment-system',
  mixins: [mixin],
  methods: {
    openUrl(bank) {
      let url = ''
      if (bank == 'privatbank') {
        url = 'https://my-payments.privatbank.ua/mypayments/customauth/identification/fp/static?staticToken=0874a578-c5fb-4712-ada1-549984cc2e91'
      } else if (bank == 'easypay') {
        url = 'https://easypay.ua/ua/catalog/utility/lvov/lvovoblenergo'
      } else if (bank == 'portmone') {
        url = 'https://www.portmone.com.ua/r3/uk/terminal/index/index/id/16738'
      } else if (bank == 'ibox') {
        url = 'http://www.iboxbank.online/ua/oplata_platezhiv.html'
      } else if (bank == 'ipay') {
        url = 'https://www.ipay.ua/ua/bills/oplata-uslug-ooo-l-vovenergosbyt-online'
      } else if (bank == 'monobank') {
        url = 'https://www.monobank.com.ua/'
      }
      window.open(url)
    }
  }
}
</script>